import React from 'react';
import FlipMove from 'react-flip-move';

import GlobalData from '../context/globaldata';

import BrewListItem from "../components/BrewListItem";

class BrewList extends React.Component {
  static contextType = GlobalData;

  render() {
    return (
      <FlipMove
        className="brew-list"
        typeName="ul"
        enterAnimation="fade"
        appearAnimation="fade"
        leaveAnimation="fade"
      >
        { this.props.brews.map((brew, index) => (
            <BrewListItem
              isActive={ this.props.activeBrewId === brew.uid ? true : false }
              brew={ brew }
              key={ brew.uid }
              db={ this.context.db }
            />
          ))
        }
      </FlipMove>
    )
  };
}

export default BrewList;
